module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"createBudgetDialog.events.successfulCreation":"Successfully created the budget \u0027{name}\u0027"}}')
  delete Component.options._Ctor
}
